export default __webpack_public_path__ + "static/NotoSansJP-Regular-9e559308cc2a99847c1bf6f0b8ac7978.otf";